import { avatarLayoutInfo } from './AvatarLayout'
import { bigTitleLayoutInfo } from './BigTitleLayout'
import { blockLayoutInfo } from './BlockLayout'
import { captionsLayoutInfo } from './CaptionsLayout'
import { chatboxLayoutInfo } from './ChatboxLayout'
import { edgyLayoutInfo } from './EdgyLayout'
import { framedLayoutInfo } from './FramedLayout'
import { memeLayoutInfo } from './MemeLayout'
import { postcardLayoutInfo } from './PostcardLayout'
import { scriptLargeLayoutInfo } from './ScriptLargeLayout'
import { scriptSmallLayoutInfo } from './ScriptSmallLayout'
import { selfPortraitLayoutInfo } from './SelfPortraitLayout'
import { translucentLayoutInfo } from './TranslucentLayout'

export const AUDIO_LAYOUTS = {
  // primeTime: primeTimeLayoutInfo,
  avatar: avatarLayoutInfo,
  bigTitle: bigTitleLayoutInfo,
  block: blockLayoutInfo,
  chatbox: chatboxLayoutInfo,
  edgy: edgyLayoutInfo,
  framed: framedLayoutInfo,
  postcard: postcardLayoutInfo,
  scriptLarge: scriptLargeLayoutInfo,
  scriptSmall: scriptSmallLayoutInfo,
  selfPortrait: selfPortraitLayoutInfo,
} as const

export const VIDEO_LAYOUTS = {
  captions: captionsLayoutInfo,
  meme: memeLayoutInfo,
  translucent: translucentLayoutInfo,
} as const

export const LAYOUTS = {
  ...AUDIO_LAYOUTS,
  ...VIDEO_LAYOUTS,
} as const

/**
 * `Layout` is defined by `LAYOUT_KEYS` in `../types/layout`, not by this
 * registry — see the comment there for why. Re-exported so existing importers
 * of `@zealous/template/layouts` keep working.
 */
import type { Layout } from '../types/layout'
export type { Layout }

/**
 * Compile-time proof that the registry above and `LAYOUT_KEYS` still describe
 * the same set. Add a layout to one and not the other and *this file* fails to
 * typecheck, naming which direction drifted.
 *
 * `Assert<T extends true>` is a constraint, so a `false` argument is an error.
 * The tuple wrappers stop the conditional from distributing over the union —
 * without them `[Layout] extends [keyof …]` would test each member separately
 * and pass vacuously. (A bare `X extends Y ? true : never` in a tuple position,
 * which an earlier draft of this used, is legal either way and asserts
 * nothing.)
 */
type Assert<T extends true> = T
type _RegistryKeysAreLayouts = Assert<
  [keyof typeof LAYOUTS] extends [Layout] ? true : false
>
type _LayoutsAreRegistryKeys = Assert<
  [Layout] extends [keyof typeof LAYOUTS] ? true : false
>
